import  React, { useState, useEffect } from 'react';
import { BASE_URL } from '../../shared/consts/baseUrl';

import { Link, useNavigate} from 'react-router-dom';
import { FormControl, Nav, Dropdown, Navbar, InputGroup } from 'react-bootstrap';
import { Imagesdata } from '../../commondata/commonimages';
import { cleanTokens, readToken, useFetch } from '@np/np_webcomponentlib';
import { API_AUTH, API_RATEDATA } from '../../shared/consts';
const SideMenuIcon: any = () => {

  //leftsidemenu
  document.querySelector(".app")?.classList.toggle("sidenav-toggled");
}
 // Darkmode
 const DarkMode = () => {


  if (document.querySelector("body")?.classList.contains('dark-mode')) {
    document.querySelector("body")?.classList.remove('dark-mode');
    
    let myonoffswitch2 = document.querySelector("#myonoffswitch1") as HTMLInputElement
    myonoffswitch2.checked = true;
    let myonoffswitch5 = document.querySelector("#myonoffswitch3") as HTMLInputElement
    myonoffswitch5.checked = true;
    let myonoffswitch8 = document.querySelector("#myonoffswitch6") as HTMLInputElement
    myonoffswitch8.checked = true;
  }
  else {
    document.querySelector("body")?.classList.add('dark-mode');
    let myonoffswitch2 = document.querySelector("#myonoffswitch2") as HTMLInputElement
    myonoffswitch2.checked = true;
    let myonoffswitch5 = document.querySelector("#myonoffswitch5") as HTMLInputElement
    myonoffswitch5.checked = true;
    let myonoffswitch8 = document.querySelector("#myonoffswitch8") as HTMLInputElement
    myonoffswitch8.checked = true;
  }
};
// SwitcherMenu

const SidSwitcherIcon: any = () => {

  //leftsidemenu
  document.querySelector(".demo_changer")?.classList.toggle("active");
  let Rightside: any = document.querySelector(".demo_changer")
  Rightside.style.insetInlineEnd = "0px";

}

const RightSideBar: any = () => {
  //leftsidemenu

  //rightsidebar
  document.querySelector(".sidebar-right")?.classList.toggle("sidebar-open");
  //swichermainright
}
const RAPIRA_SOURCE_ID = 'edefa7a7-ba66-4fd1-afa7-0698866bafdb';
const RAPIRA_GREEN_SOURCE_ID = 'a381d7fd-0e78-40fa-9a1f-144498bc70ef';

const Header = () => {

  document.querySelector('.main-content')?.addEventListener('click', ()=>{
    console.log("search-result");
    document.querySelector(".search-result")?.classList.add("d-none")
  })

  const navigate = useNavigate()

  const [rate, setRate] = useState<number | null>(null);
  const [rateGreen, setRateGreen] = useState<number | null>(null);
  const [, doFetchRate] = useFetch(`${API_RATEDATA}exhangeratedata/source/${RAPIRA_SOURCE_ID}`);
  const [, doFetchRateGreen] = useFetch(`${API_RATEDATA}exhangeratedata/source/${RAPIRA_GREEN_SOURCE_ID}`);

  useEffect(() => {
    const fetchRates = () => {
      doFetchRate({ method: 'GET' }).then((res: any) => {
        if (res?.data?.rate) setRate(res.data.rate);
      }).catch(() => {});
      doFetchRateGreen({ method: 'GET' }).then((res: any) => {
        if (res?.data?.rate) setRateGreen(res.data.rate);
      }).catch(() => {});
    };
    fetchRates();
    const interval = setInterval(fetchRates, 30000);
    return () => clearInterval(interval);
  }, []);

  const [{ response, isLoading, error }, doFetch] = useFetch(`${API_AUTH}token/logout`)

  const signOut = ()=>{
    //cleanTokens()
    const refreshToken = readToken("refreshToken");

    doFetch({
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: {"jwtRefreshToken": refreshToken}
    }).then(responce => {
      console.log('logout')
      cleanTokens()
  })


    console.log('signOut')
    //logout(`${API_AUTH}token/logout`)
    navigate("/authentication/signinplatform")
  }


  return (
    <div className=''>

      <div className='header sticky app-header header1'>
        <div className="container-fluid main-container">
          <div className="d-flex">
            <Link aria-label="Hide Sidebar" className="app-sidebar__toggle" data-bs-toggle="sidebar" to="#" onClick={() => SideMenuIcon()} />
            <Link className="logo-horizontal " to={`${BASE_URL}Dashboard`}>
              <img src={Imagesdata("logotopleft")} className="header-brand-img desktop-logo" alt="logo" />
              <img src={Imagesdata("logotopleft")} className="header-brand-img light-logo1" alt="logo" />
            </Link>
            {/* <div className="main-header-center ms-3 d-none d-lg-block">
              <FormControl placeholder="Search for results..." type="search" />
              <button className='btn px-0 pt-2'><i className="fe fe-search" aria-hidden="false"></i></button>
            </div> */}

            {(rate !== null || rateGreen !== null) && (
              <div className="d-none d-lg-flex align-items-center ms-3 gap-2" style={{ fontWeight: 600, fontSize: '13px', whiteSpace: 'nowrap' }}>
                {rate !== null && (
                  <span style={{
                    background: 'rgba(239, 68, 68, 0.12)',
                    color: '#FCA5A5',
                    padding: '4px 10px',
                    borderRadius: '999px',
                    border: '1px solid rgba(239, 68, 68, 0.25)',
                  }}>Rapira RED &mdash; {rate.toFixed(2)}</span>
                )}
                {rateGreen !== null && (
                  <span style={{
                    background: 'rgba(16, 185, 129, 0.12)',
                    color: '#6EE7B7',
                    padding: '4px 10px',
                    borderRadius: '999px',
                    border: '1px solid rgba(16, 185, 129, 0.25)',
                  }}>Rapira GREEN &mdash; {rateGreen.toFixed(2)}</span>
                )}
              </div>
            )}

            <Navbar className="d-flex order-lg-2 ms-auto header-right-icons">
              <Dropdown className="dropdown d-none">
                <Link to="#" className="nav-link icon " >
                  <i className="fe fe-search"></i>
                </Link>
                <Dropdown.Menu className="header-search dropdown-menu-start ">
                  <InputGroup className="input-group w-100 p-2">
                    <FormControl type="text" placeholder="Search...." />
                    <InputGroup.Text className="btn btn-primary">
                      <i className="fe fe-search" aria-hidden="true"></i>
                    </InputGroup.Text>
                  </InputGroup>
                </Dropdown.Menu>
              </Dropdown>
              <Navbar.Toggle className="d-lg-none ms-auto header2">
                <span className="navbar-toggler-icon fe fe-more-vertical"></span>
              </Navbar.Toggle>

              <div className="responsive-navbar p-0">

                <Navbar.Collapse className="" id="navbarSupportedContent-4">
                  <div className="d-flex order-lg-2">
                    <Dropdown className="d-lg-none d-flex" >
                      <Dropdown.Toggle href="#" className="nav-link icon no-caret">
                        <i className="fe fe-search"></i>
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="header-search dropdown-menu-start">
                        <InputGroup className="w-100 p-2">
                          <FormControl type="text" placeholder="Search...." />
                          <InputGroup.Text>
                            <i className="fa fa-search" aria-hidden="true" ></i>
                          </InputGroup.Text>
                        </InputGroup>
                      </Dropdown.Menu>
                    </Dropdown>

                    {/* Dark Mode */}

                    <div className="dropdown  d-flex">
                      <Nav.Link className="nav-link icon theme-layout nav-link-bg layout-setting" onClick={() => DarkMode()}>
                        <span className="dark-layout"><i className="fe fe-moon"></i></span>
                        <span className="light-layout"><i className="fe fe-sun"></i></span>
                      </Nav.Link>
                    </div>

                    {/* Right Side-bar */}

                    {/* <div className="dropdown d-flex header-settings" onClick={() => RightSideBar()}>
                      <Link to="#;" className="nav-link icon"
                        data-bs-toggle="sidebar-right" data-target=".sidebar-right">
                        <i className="fe fe-align-right"></i>
                      </Link>
                    </div> */}

                    {/* Profile  */}

                    <Dropdown className="d-flex profile-1">
                      <Dropdown.Toggle variant='' className="nav-link leading-none d-flex no-caret">
                        <img src={Imagesdata("users21")} alt="profile-user"
                          className="avatar  profile-user brround cover-image" />
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="dropdown-menu-end dropdown-menu-arrow">
                        {/* <div className="drop-heading">
                          <div className="text-center">
                            <h5 className="text-dark mb-0 fs-14 fw-semibold">Percy Kewshun</h5>
                            <small className="text-muted">Senior Admin</small>
                          </div>
                        </div>
                        <div className="dropdown-divider m-0"></div>
                        <Link className="dropdown-item" to={`${BASE_URL}Pages/profile`}>
                          <i className="dropdown-icon fe fe-user"></i> Profile
                        </Link>
                        <Link className="dropdown-item" to={`${BASE_URL}Pages/mailinbox/`}>
                          <i className="dropdown-icon fe fe-mail"></i> Inbox
                          <span className="badge bg-danger rounded-pill float-end">5</span>
                        </Link>
                        <Link className="dropdown-item" to={`${BASE_URL}Authentication/lockscreen/`}>
                          <i className="dropdown-icon fe fe-lock"></i> Lockscreen
                        </Link> */}
                        <Dropdown.Item className="dropdown-item" onClick={signOut}>
                          <i className="dropdown-icon fe fe-alert-circle"></i> Sign out
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>

                  </div>
                </Navbar.Collapse>
              </div>

              {/* Switcher  */}

              {/* <div className="demo-icon nav-link icon" onClick={() => SidSwitcherIcon()}>
                <i className="fe fe-settings fa-spin  text_primary"></i>
              </div> */}

            </Navbar>
          </div>
        </div>
      </div>
    </div>
  )

};

export default Header;
